import "core-js/modules/es.number.constructor.js";
import { defineComponent, ref } from "vue";
export default defineComponent({
  name: "listDetailNav",
  props: {
    navList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    commentTotal: {
      type: Number,
      default: 0
    },
    navColor: {
      type: String,
      default: "red"
    },
    navMarginR: {
      type: String,
      default: "20px"
    }
  },
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var isActive = ref(0);
    /* 导航点击事件 */

    var titleClick = function titleClick(index) {
      if (isActive.value !== index) {
        emit("titleClick", index);
      }

      isActive.value = index;
    };

    return {
      isActive: isActive,
      titleClick: titleClick
    };
  },
  components: {}
});